<script setup lang="ts"></script>

<template>
  <MarvelBoxy :class="'marvel-banner'" :type="'type3'">
    <div class="marvel-banner__message">
      Play to win 3 in-game and cash items! Then double one of those items for 1,000 NX!
    </div>
  </MarvelBoxy>
</template>

<style lang="scss" scoped>
  .marvel-banner {
    display: inline-block;
    position: absolute;
    width: calc(350px * var(--marvel-desktopRatio));
    left: calc(30px * var(--marvel-desktopRatio));
    top: calc(30px * var(--marvel-desktopRatio));
    z-index: 5;
    opacity: 0.83;
  }
  .marvel-banner__message {
    text-align: center;
    font-family: 'maplestory-bold';
    line-height: 1.2em;
    font-size: calc(19px * var(--marvel-desktopRatio));
    padding: calc(10px * var(--marvel-desktopRatio));
  }
  @media #{$tabletForMarvel} {
    .marvel-banner {
      display: none;
    }
  }
</style>
